<template>
  <div class="form">
  	<div class="item">
  		<div class="label">父级菜单:</div>
	  	<el-select v-model="info.fid" filterable placeholder="请选择父级菜单">
		    <el-option
		      v-for="item in options"
		      :key="item.id"
		      :label="item.menu_name"
		      :value="item.id">
		    </el-option>
		  </el-select>
		</div>
		<div class="item">
  		<div class="label">菜单级别:</div>
	  	<el-select v-model="info.type" filterable placeholder="请选择菜单级别">
		    <el-option
		      v-for="item in menuClass"
		      :key="item.type"
		      :label="item.type"
		      :value="item.type">
		    </el-option>
		  </el-select>
		</div>
		<div class="item">
  		<div class="label">菜单名:</div>
	  	<el-input v-model="info.menu_name" placeholder="请输入菜单名"></el-input>
		</div>
		<div class="item">
  		<div class="label">菜单url:</div>
	  	<el-input v-model="info.menu_url" placeholder="请输入菜单url"></el-input>
		</div>
		<el-button type="primary" @click="onAddRouterClick">提交</el-button>
  </div>
</template>
<script>
import { routerlist, newrouter } from '@/api/router-manage';

export default {
  name: 'addrouter',
  data() {
    return {
    	info: {
    		fid: '',
        menu_name: '',
        menu_url: '',
        type: ''
    	},
    	options: [],
    	menuClass: [
        {id: 1, type: '1'},
        {id: 2, type: '2'},
        {id: 3, type: '3'},
    	]
    }
  },
  mounted() {
    this.getRouterList();
  },
  methods: {
    async getRouterList() {
      const { data, status } = await routerlist();
      if (status !== 200) return
      this.options = data.char;
      console.log(data, 'router-list') 
    },
    async onAddRouterClick () {
      const { fid } = this.info;
      fid? '' :  this.info.fid = '0';
      const { data, status } = await newrouter(this.info);
      console.log(data, status, '新增数据')
      if (status !== 200) return
      //新增路由成功后把表单清空并重新获取路由列表
      this.info = {};
      this.getRouterList();
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/rem-mixins.less';

.form {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
  margin-top: 20px;
  .item {
  	display: flex;
  	align-items: center;
  	margin-bottom: 20px;
    .label {
    	margin-right: 10px;
    	width: 80px;
    }
  }
}
</style>
